import React from 'react';
import { Link } from 'react-router-dom';
import LazyLoad from 'react-lazyload';
const Footer = () => {
  return (
    <>
      <div className="footer padded-sec">
        <div className='abs-list ftrShape1'> 
        </div>
        <div className='container-fluid'>
          <div className='row'>
            <div className='col-xxl-3 col-xl-2 col-lg-6 col-sm-6 col-xs-12'>
               <Link to="/"><div className='ftr-logo'> 
                  <img src="https://webapi.entab.info/api/image/SJCSQP/public/Images/footerlogo.png" className="img-fluid" alt="St. Joseph's School Quadian Punjab" />  
              </div>
              </Link>
              <ul className='socialMedia'> 
                <li><Link to="#" target="_blank"><img src="https://webapi.entab.info/api/image/SJCSQP/public/Images/linked.png" className="img-fluid" alt="St. Joseph's School Quadian Punjab"/></Link></li>
                <li><Link to="#" target="_blank"><img src="https://webapi.entab.info/api/image/SJCSQP/public/Images/facebook.png" className="img-fluid" alt="St. Joseph's School Quadian Punjab"/></Link></li>
                <li><Link to="#" target="_blank"><img src="https://webapi.entab.info/api/image/SJCSQP/public/Images/insta.png" className="img-fluid" alt="St. Joseph's School Quadian Punjab"/></Link></li>
              </ul>
            </div>
            <div className='col-xxl-2 col-xl-2 col-lg-6 col-sm-6 col-xs-12 address'>
              <h3>Locate us</h3>
              <p><i class="bi bi-house-door-fill"></i> <span><Link to="https://maps.app.goo.gl/8dqefciqntnrbccv6" target="_blank"> St. Joseph's School Qadian Punjab</Link></span></p>
              <p><i class="bi bi-telephone-fill"></i> <span><a href="tel:91-9876414190">91-9876414190</a> </span></p>
              <p><i class="bi bi-envelope-fill"></i> <span> <a href="mailto:stjosephconventschoolqadian@gmail.com ">stjosephconventschoolqadian@gmail.com </a> </span></p>
            </div>
            <div className='col-xxl-5 col-xl-6 col-lg-12 col-sm-12 col-xs-12'>
            <h3>useful links</h3>
              <div className='quick-link'>
              
                <ul> 
                  <li><Link to="/AboutUs"><i class="bi bi-caret-right-fill"></i> ABOUT</Link></li>  
                  <li><Link to="/ErpSoftware"><i class="bi bi-caret-right-fill"></i>  ERP SOFTWARE </Link></li>
                  <li><Link to="https://portalguidelines.campuscare.info/index.html#SJCQPB" target="_blank"><i class="bi bi-caret-right-fill"></i>   PORTAL (HELP?)</Link></li> 
                  <li><Link to="/Tc"><i class="bi bi-caret-right-fill"></i>  TRANSFER CERTIFICATE </Link></li>  
                   
                </ul>
                <div className='ph-flex'>
                <div className="app-cont">
                  <h3>Download Mobile App</h3>
                  <p>  CampusCare 10x mobile app for parents is a tool that serves as a single point of reference for parents. The app centralises all the school-parent interaction and lets parents stay updated with their ward's day-to-day activities. Parents can receive assignments, homework, and circulars, keep track of their child's attendance, do online fee payment, view report cards.</p>
                  <div>
                    <a href="https://apps.apple.com/in/app/campuscare-10x/id1611283814" target="_blank">
                      <LazyLoad><img src="https://webapi.entab.info/api/image/SJCSQP/public/Images/apple.png" className="img-fluid" /></LazyLoad>
                    </a>
                    <a href="https://play.google.com/store/apps/details?id=com.entab.learninglab&amp;hl=en-IN" target="_blank">
                      <LazyLoad><img src="https://webapi.entab.info/api/image/SJCSQP/public/Images/playstore.png" className="img-fluid" /></LazyLoad>
                    </a>
                  </div>
                  <p className="link"><Link to="https://entab.online/SJCQPB" target="_blank">School Code : SJCQPB</Link></p>
                </div>
                <div className='mobile-icon'>
                  <LazyLoad><img src="https://webapi.entab.info/api/image/SJCSQP/public/Images/mobile-icon.png" className="img-fluid" /></LazyLoad>
                </div>
              </div>
              </div>
            </div> 
            <div className='col-xxl-2 col-xl-2 col-lg-12 col-sm-12 col-xs-12'>
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6781.301247081722!2d75.3479206935791!3d31.80727039999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391bbf6e16fe5a35%3A0xce8b5c07c7c65ad9!2sSt%20Joseph%20Convent%20School!5e0!3m2!1sen!2sin!4v1753334212659!5m2!1sen!2sin" width="100%" height="200px" frameborder="0" allowfullscreen=""></iframe>
              </div>
          </div> 
        </div>
      </div>
      <div className='copyright'>
      ©️ 2025 St. Joseph Convent School | Accelerating By <Link to="https://www.entab.in/" target="_blank">Entab Infotech: CampusCare®️ </Link>
      </div>
    </>
  );
}

export default Footer;
